export default "__VITE_ASSET__T6DTYgyL__"